import React, { useMemo, useState } from "react";
import { DatePicker, Pagination, Select } from "antd";
import dayjs from "dayjs";
import {
  Search, ChevronLeft, ChevronRight, Download, Eye, MessageSquare,
  X, Bot, User, Clock3, RefreshCw,
} from "lucide-react";
import HeaderCompo from "../../component/Header";

const dummyApiData = [

  {

    id: "2204",

    message_id: "3415debd2c5d988a",

    track_id: "track_c60c9c4f3726d5d0",

    msg: "answer my question",

    ts: "2026-09-25 19:34:45.344174+00",

    u: {

      _id: "781",

      name: "Sammy",

      username: "sammy.salem@aaparx.com",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2203",

    message_id: "e1c34fc781f9a0bd",

    track_id: "track_c60c9c4f3726d5d0",

    msg: "For calendar quarter 2026-Q3, your Cost of goods (COGs) was 5.55%.",

    ts: "2026-09-25 19:34:33.399055+00",

    u: {

      _id: "bot_id",

      name: "bot",

      username: "bot",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2202",

    message_id: "3e82bf08c26a62e7",

    track_id: "track_c60c9c4f3726d5d0",

    msg: "if i do not buy any more ozempic what does that do to my gcr and brand cogs",

    ts: "2026-09-25 19:34:31.01098+00",

    u: {

      _id: "781",

      name: "Sammy",

      username: "sammy.salem@aaparx.com",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2201",

    message_id: "194ff56f1162a17b",

    track_id: "track_c60c9c4f3726d5d0",

    msg: "You're welcome! If you have any other questions, feel free to ask.",

    ts: "2026-09-25 19:33:16.292024+00",

    u: {

      _id: "bot_id",

      name: "bot",

      username: "bot",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2200",

    message_id: "651b58052d5ba9d4",

    track_id: "track_c60c9c4f3726d5d0",

    msg: "thanks",

    ts: "2026-09-25 19:33:14.864919+00",

    u: {

      _id: "781",

      name: "Sammy",

      username: "sammy.salem@aaparx.com",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2198",

    message_id: "df336ddb5b437031",

    track_id: "track_c60c9c4f3726d5d0",

    msg: "you are worthless",

    ts: "2026-09-25 19:33:08.360057+00",

    u: {

      _id: "781",

      name: "Sammy",

      username: "sammy.salem@aaparx.com",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2197",

    message_id: "8ecb1e75321f7b6e",

    track_id: "track_c60c9c4f3726d5d0",

    msg: "I don’t have the information needed to answer that question.",

    ts: "2026-09-25 19:33:00.501225+00",

    u: {

      _id: "bot_id",

      name: "bot",

      username: "bot",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2196",

    message_id: "ae7bf56ab8759c76",

    track_id: "track_c60c9c4f3726d5d0",

    msg: "I want to buy less generics from mckesson and more from the secondary market",

    ts: "2026-09-25 19:32:59.722538+00",

    u: {

      _id: "781",

      name: "Sammy",

      username: "sammy.salem@aaparx.com",

    },

    primary_account_ids: [96167],

  },



  /* -----------------------------------------------

     Conversation 2

  ------------------------------------------------ */

  {

    id: "2177",

    message_id: "ab7c2e6d65b0e818",

    track_id: "track_5b6708588ef203c8",

    msg: "Not doing what I asked",

    ts: "2026-09-24 15:37:25.952161+00",

    u: {

      _id: "592",

      name: "SHAMS",

      username: "shams.shibley@aaparx.com",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2178",

    message_id: "17ca875ff37a40de",

    track_id: "track_5b6708588ef203c8",

    msg: "Your GCR % can improve from 11.34% to 12.00% by increasing generic Rx spend by $5,170.05.",

    ts: "2026-09-24 15:37:31.663694+00",

    u: {

      _id: "bot_id",

      name: "bot",

      username: "bot",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2175",

    message_id: "3f61c460e08e4619",

    track_id: "track_5b6708588ef203c8",

    msg: "Can you provide a daily spend breakdown to get to my goal GCR?",

    ts: "2026-09-24 15:37:08.506678+00",

    u: {

      _id: "592",

      name: "SHAMS",

      username: "shams.shibley@aaparx.com",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2174",

    message_id: "ebe43fe4b3b8ba90",

    track_id: "track_5b6708588ef203c8",

    msg: "To reach a 12.00% GCR, increase generic Rx spend by $5,170.05 daily while keeping brand spend steady.",

    ts: "2026-09-24 15:35:32.00707+00",

    u: {

      _id: "bot_id",

      name: "bot",

      username: "bot",

    },

    primary_account_ids: [96167],

  },



  /* -----------------------------------------------

     Conversation 3

  ------------------------------------------------ */

  {

    id: "2170",

    message_id: "164316c0e3c3f1d4",

    track_id: "track_e73943c9e8d7eeaa",

    msg: "GLP1 spend is under the brandrx spend category",

    ts: "2026-09-23 17:07:05.308687+00",

    u: {

      _id: "1161",

      name: "Kyle",

      username: "kshinn@myicbn.com",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2171",

    message_id: "62478a14e71a13fa",

    track_id: "track_e73943c9e8d7eeaa",

    msg: "I don’t have the information needed to answer that question.",

    ts: "2026-09-23 17:07:06.92092+00",

    u: {

      _id: "bot_id",

      name: "bot",

      username: "bot",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2168",

    message_id: "1332efd350d270c2",

    track_id: "track_e73943c9e8d7eeaa",

    msg: "What happens if I increase GLP1 spend by $30,000 this month",

    ts: "2026-09-23 17:02:05.756896+00",

    u: {

      _id: "1161",

      name: "Kyle",

      username: "kshinn@myicbn.com",

    },

    primary_account_ids: [96167],

  },

  {

    id: "2167",

    message_id: "e4db6b63317964a3",

    track_id: "track_e73943c9e8d7eeaa",

    msg: "Yes — increasing Onestop spend by $30,000 this month raises generic rebates by $6,600.00 and improves SGCR to 17.04%.",

    ts: "2026-09-23 17:01:37.83322+00",

    u: {

      _id: "bot_id",

      name: "bot",

      username: "bot",

    },

    primary_account_ids: [96167],

  },



  /* -----------------------------------------------

     Conversation 4

  ------------------------------------------------ */

  {

    id: "2159",

    message_id: "5856f7a9222b7395",

    track_id: "track_57d36f03e8ee8544",

    msg: "What if I don't need those additional generic $$$",

    ts: "2026-09-23 16:36:48.110158+00",

    u: {

      _id: "487",

      name: "Kelli",

      username: "kelli.sneed@aaparx.com",

    },

    primary_account_ids: [194749],

  },

  {

    id: "2160",

    message_id: "3a11de05136bb9b4",

    track_id: "track_57d36f03e8ee8544",

    msg: "If you do not increase your generic spend, your brand COGs percentage will remain at 2.50% and your GCR will stay at 1.61%.",

    ts: "2026-09-23 16:36:52.457568+00",

    u: {

      _id: "bot_id",

      name: "bot",

      username: "bot",

    },

    primary_account_ids: [194749],

  },

  {

    id: "2157",

    message_id: "4339b259b9f6b8a3",

    track_id: "track_57d36f03e8ee8544",

    msg: "Can you recommend a strategy to improve my COGs?",

    ts: "2026-09-23 16:36:18.633524+00",

    u: {

      _id: "487",

      name: "Kelli",

      username: "kelli.sneed@aaparx.com",

    },

    primary_account_ids: [194749],

  },

];





/* =========================================================

   HELPERS

========================================================= */





const isBot = (message) => message?.u?._id === "bot_id";

const formatDate = (date) => new Intl.DateTimeFormat("en-US", {
  month: "short", day: "numeric", year: "numeric",
}).format(new Date(date));

const formatTime = (date) => new Intl.DateTimeFormat("en-US", {
  hour: "2-digit", minute: "2-digit",
}).format(new Date(date));

const getInitials = (name = "") => name.split(" ").map((word) => word[0]).join("").slice(0, 2).toUpperCase();

const stripHtml = (value = "") => value
  .replace(/<br\s*\/?\s*>/gi, "\n")
  .replace(/<\/(p|div|li|tr|h[1-6])>/gi, "\n")
  .replace(/<li[^>]*>/gi, "• ")
  .replace(/<[^>]*>/g, "")
  .replace(/&nbsp;/gi, " ")
  .replace(/&amp;/gi, "&")
  .replace(/&lt;/gi, "<")
  .replace(/&gt;/gi, ">")
  .replace(/\n{3,}/g, "\n\n")
  .replace(/[ \t]+\n/g, "\n")
  .trim();

const getUserMessage = (messages) => [...messages].reverse().find((message) => !isBot(message))?.msg || "No user question";
const getLatestMessage = (messages) => [...messages].sort((a, b) => new Date(b.ts) - new Date(a.ts))[0];

const buildConversations = (rows) => {
  const grouped = {};
  rows.forEach((row) => {
    if (!grouped[row.track_id]) grouped[row.track_id] = [];
    grouped[row.track_id].push({ ...row, parsedDate: new Date(row.ts) });
  });

  return Object.entries(grouped).map(([trackId, messages]) => {
    const sortedMessages = [...messages].sort((a, b) => new Date(a.ts) - new Date(b.ts));
    const firstUserMessage = sortedMessages.find((message) => !isBot(message)) || sortedMessages[0];
    const user = firstUserMessage?.u || {};
    return {
      trackId,
      userId: user?._id,
      userName: user?.name || "Unknown User",
      email: user?.username || "-",
      accountId: firstUserMessage?.primary_account_ids?.[0] || "-",
      messages: sortedMessages,
      startedAt: sortedMessages[0]?.parsedDate,
      lastMessageAt: sortedMessages[sortedMessages.length - 1]?.parsedDate,
      question: stripHtml(getUserMessage(sortedMessages)),
      latestMessage: getLatestMessage(sortedMessages),
    };
  }).sort((a, b) => b.startedAt - a.startedAt);
};

export default function ChatHistory() {
  const [rawData] = useState(dummyApiData);
  const [selectedChat, setSelectedChat] = useState(null);
  const [showChatModal, setShowChatModal] = useState(false);
  const [search, setSearch] = useState("");
  const [userFilter, setUserFilter] = useState("all");
  const [fromDate, setFromDate] = useState("2026-09-23");
  const [toDate, setToDate] = useState("2026-09-25");
  const [activeQuickFilter, setActiveQuickFilter] = useState("30");
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [updatedDates, setUpdatedDates] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const conversations = useMemo(() => buildConversations(rawData), [rawData]);

  const users = useMemo(() => {
    const uniqueUsers = new Map();
    conversations.forEach((chat) => uniqueUsers.set(chat.userId, { id: chat.userId, name: chat.userName }));
    return [...uniqueUsers.values()];
  }, [conversations]);

  const filteredConversations = useMemo(() => conversations.filter((chat) => {
    const chatDate = dayjs(chat.startedAt);
    const start = fromDate ? dayjs(fromDate).startOf("day") : null;
    const end = toDate ? dayjs(toDate).endOf("day") : null;
    const matchesDate = (!start || !chatDate.isBefore(start)) && (!end || !chatDate.isAfter(end));
    const matchesUser = userFilter === "all" || chat.userId === userFilter;
    const searchValue = search.toLowerCase().trim();
    const matchesSearch = !searchValue || chat.userName.toLowerCase().includes(searchValue) || chat.email.toLowerCase().includes(searchValue) || chat.question.toLowerCase().includes(searchValue) || chat.trackId.toLowerCase().includes(searchValue);
    return matchesDate && matchesUser && matchesSearch;
  }), [conversations, fromDate, toDate, userFilter, search]);

  const totalPages = Math.max(1, Math.ceil(filteredConversations.length / rowsPerPage));
  const paginatedConversations = filteredConversations.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const applyQuickFilter = (type) => {
    const today = dayjs();
    let start = today;
    if (type === "7") start = today.subtract(7, "day");
    if (type === "30") start = today.subtract(30, "day");
    setFromDate((type === "today" ? today : start).format("YYYY-MM-DD"));
    setToDate(today.format("YYYY-MM-DD"));
    setActiveQuickFilter(type);
    setCurrentPage(1);
  };

  const openChat = (chat) => {
    setSelectedChat(chat);
    setShowChatModal(true);
  };

  const handleUpdateDate = (newDate) => {
    if (!selectedChat || !newDate) return;
    setUpdatedDates((previous) => ({ ...previous, [selectedChat.trackId]: newDate }));
    setShowUpdateModal(false);
  };

  const handleRangeChange = (dates) => {
    if (!dates) {
      setFromDate("");
      setToDate("");
      setActiveQuickFilter(null);
      setCurrentPage(1);
      return;
    }
    setFromDate(dates[0]?.format("YYYY-MM-DD") || "");
    setToDate(dates[1]?.format("YYYY-MM-DD") || "");
    setActiveQuickFilter(null);
    setCurrentPage(1);
  };

  const exportCsv = () => {
    const headers = ["Date", "Time", "User", "Email", "Question", "Bot Answer", "Track ID"];
    const rows = filteredConversations.map((chat) => [formatDate(chat.startedAt), formatTime(chat.startedAt), chat.userName, chat.email, stripHtml(chat.question), stripHtml(chat.latestMessage?.msg || ""), chat.trackId]);
    const csv = [headers, ...rows].map((row) => row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `chat-history-${fromDate || "all"}-to-${toDate || "all"}.csv`;
    link.click();
    URL.revokeObjectURL(url);
    setShowExportModal(false);
  };

  return (
    <>
      <HeaderCompo initialColor={"#000833"} />
      <main className="min-h-screen bg-[#f8fafc] px-3 py-5 sm:px-5 lg:px-7">
        <div className="mx-auto w-full max-w-[1600px]">
          <div className="mb-5 flex flex-col gap-4 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex items-center gap-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 text-blue-600"><MessageSquare size={18} /></div>
              <div>
                <h1 className="text-2xl font-bold tracking-tight text-slate-800 sm:text-3xl">Chat History</h1>
                <p className="mt-1 text-sm text-slate-500">View and manage all user conversations with the AI bot.</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              <button onClick={() => selectedChat && setShowUpdateModal(true)} disabled={!selectedChat} className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"><RefreshCw size={16} /><span className="hidden sm:inline">Update Date</span></button>
              <button onClick={() => setShowExportModal(true)} className="inline-flex items-center justify-center gap-2 rounded-xl bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700"><Download size={16} />Export Chats</button>
            </div>
          </div>

          <div className="mb-5 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-5">
              <div>
                <label className="mb-1.5 block text-xs font-semibold text-slate-500">From Date</label>
                <DatePicker value={fromDate ? dayjs(fromDate) : null} onChange={(date) => { setFromDate(date ? date.format("YYYY-MM-DD") : ""); setActiveQuickFilter(null); setCurrentPage(1); }} format="DD MMM YYYY" allowClear className="!h-[42px] !w-full" />
              </div>
              <div>
                <label className="mb-1.5 block text-xs font-semibold text-slate-500">To Date</label>
                <DatePicker value={toDate ? dayjs(toDate) : null} onChange={(date) => { setToDate(date ? date.format("YYYY-MM-DD") : ""); setActiveQuickFilter(null); setCurrentPage(1); }} format="DD MMM YYYY" allowClear className="!h-[42px] !w-full" />
              </div>
              <div>
                <label className="mb-1.5 block text-xs font-semibold text-slate-500">Date Range</label>
                <DatePicker.RangePicker value={fromDate && toDate ? [dayjs(fromDate), dayjs(toDate)] : null} onChange={handleRangeChange} format="DD MMM YYYY" allowClear className="!h-[42px] !w-full" />
              </div>
              <div>
                <label className="mb-1.5 block text-xs font-semibold text-slate-500">User</label>
                <Select value={userFilter} onChange={(value) => { setUserFilter(value); setCurrentPage(1); }} className="h-[42px] w-full" options={[{ value: "all", label: "All Users" }, ...users.map((user) => ({ value: user.id, label: user.name }))]} />
              </div>
              <div>
                <label className="mb-1.5 block text-xs font-semibold text-slate-500">Search</label>
                <div className="relative"><Search size={17} className="absolute left-3 top-1/2 z-10 -translate-y-1/2 text-slate-400" /><input value={search} onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }} placeholder="Search user, email, question or track ID..." className="h-[42px] w-full rounded-xl border border-slate-200 bg-white py-2.5 pl-10 pr-4 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100" /></div>
              </div>
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-slate-100 pt-4">
              <span className="mr-1 text-xs font-semibold text-slate-500">Quick filter:</span>
              {[['today', 'Today'], ['7', 'Last 7 Days'], ['30', 'Last 30 Days']].map(([value, label]) => <button key={value} onClick={() => applyQuickFilter(value)} className={`rounded-full border px-4 py-1.5 text-xs font-semibold transition ${activeQuickFilter === value ? 'border-blue-200 bg-blue-50 text-blue-600' : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50'}`}>{label}</button>)}
              <button onClick={() => setActiveQuickFilter(null)} className={`rounded-full border px-4 py-1.5 text-xs font-semibold ${!activeQuickFilter ? 'border-blue-200 bg-blue-50 text-blue-600' : 'border-slate-200 bg-white text-slate-600'}`}>Custom Range</button>
            </div>
          </div>

          <section className="min-w-0 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
            <div className="flex flex-col gap-2 border-b border-slate-100 px-5 py-4 sm:flex-row sm:items-center sm:justify-between"><div><h2 className="text-lg font-bold text-slate-800">Chat Conversations</h2><p className="text-xs text-slate-400">{filteredConversations.length} conversations</p></div><div className="text-xs text-slate-400">Click View to open the complete conversation</div></div>
            <div className="hidden overflow-x-auto md:block">
              <table className="min-w-[1050px] w-full">
                <thead className="bg-slate-50 text-left text-[11px] font-bold uppercase tracking-wide text-slate-400"><tr><th className="px-4 py-3">Date</th><th className="px-4 py-3">Time</th><th className="px-4 py-3">User</th><th className="px-4 py-3">Email</th><th className="px-4 py-3">User Question</th><th className="px-4 py-3">Bot Answer</th><th className="px-4 py-3 text-center">Action</th></tr></thead>
                <tbody>
                  {paginatedConversations.map((chat) => <tr key={chat.trackId} className="border-b border-slate-100 transition hover:bg-blue-50/40"><td className="whitespace-nowrap px-4 py-4 text-xs font-medium text-slate-600">{formatDate(chat.startedAt)}</td><td className="whitespace-nowrap px-4 py-4 text-xs text-slate-500">{formatTime(chat.startedAt)}</td><td className="px-4 py-4"><div className="flex items-center gap-2.5"><div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-100 text-[10px] font-bold text-blue-600">{getInitials(chat.userName)}</div><div className="max-w-[130px] truncate text-xs font-semibold text-slate-700">{chat.userName}</div></div></td><td className="max-w-[170px] truncate px-4 py-4 text-xs text-slate-500">{chat.email}</td><td className="max-w-[190px] px-4 py-4"><p className="line-clamp-2 text-xs leading-5 text-slate-600">{chat.question}</p></td><td className="max-w-[190px] px-4 py-4"><p className="line-clamp-2 text-xs leading-5 text-slate-500">{stripHtml(chat.latestMessage?.msg || '')}</p></td><td className="px-4 py-4 text-center"><button onClick={() => openChat(chat)} className="inline-flex items-center gap-1.5 rounded-lg border border-blue-200 bg-white px-3 py-1.5 text-xs font-semibold text-blue-600 transition hover:bg-blue-50"><Eye size={14} />View</button></td></tr>)}
                </tbody>
              </table>
            </div>

            <div className="divide-y divide-slate-100 md:hidden">
              {paginatedConversations.map((chat) => <button key={chat.trackId} onClick={() => openChat(chat)} className="w-full bg-white p-4 text-left transition hover:bg-blue-50/50"><div className="flex items-start gap-3"><div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-100 text-xs font-bold text-blue-600">{getInitials(chat.userName)}</div><div className="min-w-0 flex-1"><div className="flex items-start justify-between gap-2"><div className="min-w-0"><p className="truncate text-sm font-bold text-slate-700">{chat.userName}</p><p className="truncate text-[11px] text-slate-400">{chat.email}</p></div><span className="shrink-0 rounded-lg border border-blue-200 px-2.5 py-1 text-[10px] font-semibold text-blue-600">View</span></div><div className="mt-3 grid grid-cols-2 gap-2 text-[10px]"><div className="rounded-lg bg-slate-50 p-2"><span className="text-slate-400">Date</span><p className="mt-0.5 font-semibold text-slate-600">{formatDate(chat.startedAt)}</p></div><div className="rounded-lg bg-slate-50 p-2"><span className="text-slate-400">Messages</span><p className="mt-0.5 font-semibold text-slate-600">{chat.messages.length}</p></div></div><p className="mt-3 line-clamp-3 text-xs leading-5 text-slate-600">{chat.question}</p></div></div></button>)}
            </div>

            {/* <div className="flex flex-col gap-3 border-t border-slate-100 px-4 py-3 sm:flex-row sm:items-center sm:justify-between"><div className="flex items-center gap-2 text-xs text-slate-500"><span>Rows</span><select value={rowsPerPage} onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }} className="rounded-lg border border-slate-200 bg-white px-2 py-1.5 text-xs outline-none">{[5,10,20,50].map((size) => <option key={size} value={size}>{size}</option>)}</select><span>of {filteredConversations.length}</span></div><div className="flex items-center justify-between gap-2 sm:justify-end"><button disabled={currentPage === 1} onClick={() => setCurrentPage((page) => Math.max(1, page - 1))} className="flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 text-slate-500 disabled:opacity-40"><ChevronLeft size={15}/></button><span className="min-w-[90px] text-center text-xs font-semibold text-slate-600">Page {currentPage} of {totalPages}</span><button disabled={currentPage === totalPages} onClick={() => setCurrentPage((page) => Math.min(totalPages, page + 1))} className="flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 text-slate-500 disabled:opacity-40"><ChevronRight size={15}/></button></div>
            </div> */}

{/* =================================================
    PAGINATION
================================================= */}
<div className="flex flex-col gap-4 border-t border-slate-100 bg-white px-4 py-4 sm:px-5 lg:flex-row lg:items-center lg:justify-between">

  {/* Left: Result info + rows per page */}
  <div className="flex flex-wrap items-center justify-between gap-3 sm:justify-start">
    <p className="text-xs text-slate-500">
      Showing{" "}
      <span className="font-semibold text-slate-700">
        {filteredConversations.length === 0
          ? 0
          : (currentPage - 1) * rowsPerPage + 1}
      </span>
      {" - "}
      <span className="font-semibold text-slate-700">
        {Math.min(
          currentPage * rowsPerPage,
          filteredConversations.length
        )}
      </span>
      {" of "}
      <span className="font-semibold text-slate-700">
        {filteredConversations.length}
      </span>
    </p>

    {/* Rows per page */}
    <div className="flex items-center gap-2">
      <span className="text-xs text-slate-500">
        Rows per page
      </span>

      <select
        value={rowsPerPage}
        onChange={(e) => {
          setRowsPerPage(Number(e.target.value));
          setCurrentPage(1);
        }}
        className="
          h-8 rounded-lg
          border border-slate-200
          bg-white px-2.5
          text-xs font-medium text-slate-700
          outline-none transition
          focus:border-blue-400
          focus:ring-2 focus:ring-blue-100
        "
      >
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={50}>50</option>
      </select>
    </div>
  </div>

  {/* Ant Design Pagination */}
  {totalPages > 1 && (
    <Pagination
      current={currentPage}
      pageSize={rowsPerPage}
      total={filteredConversations.length}
      showSizeChanger={false}
      showQuickJumper={false}
      showLessItems={false}
      responsive
      onChange={(page) => {
        setCurrentPage(page);
      }}
      itemRender={(page, type, originalElement) => {
        if (type === "prev") {
          return (
            <button
              type="button"
              className="
                flex h-8 w-8 items-center justify-center
                rounded-lg
                border border-slate-200
                bg-white
                text-slate-500
                transition
                hover:border-blue-200
                hover:bg-blue-50
                hover:text-blue-600
              "
            >
              <ChevronLeft size={15} />
            </button>
          );
        }

        if (type === "next") {
          return (
            <button
              type="button"
              className="
                flex h-8 w-8 items-center justify-center
                rounded-lg
                border border-slate-200
                bg-white
                text-slate-500
                transition
                hover:border-blue-200
                hover:bg-blue-50
                hover:text-blue-600
              "
            >
              <ChevronRight size={15} />
            </button>
          );
        }

        if (type === "jump-prev" || type === "jump-next") {
          return (
            <span
              className="
                flex h-8 w-8
                items-center justify-center
                text-xs font-medium
                text-slate-400
              "
            >
              ...
            </span>
          );
        }

        return (
          <button
            type="button"
            className="
              flex h-8 min-w-8
              items-center justify-center
              rounded-lg
              border border-slate-200
              bg-white
              px-2
              text-xs font-semibold
              text-slate-600
              transition
              hover:border-blue-200
              hover:bg-blue-50
              hover:text-blue-600
            "
          >
            {page}
          </button>
        );
      }}
    />
  )}
</div> 
          </section>
        </div>
      </main>

      {showChatModal && selectedChat && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/50 p-3 backdrop-blur-sm sm:p-5" onClick={() => setShowChatModal(false)}>
        <div className="flex h-[94vh] w-full max-w-5xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl" onClick={(e) => e.stopPropagation()}>
          <div className="shrink-0 border-b border-slate-200 bg-white px-4 py-4 sm:px-6">
            <div className="flex items-start justify-between gap-4"><div className="flex min-w-0 items-center gap-3"><div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-100 text-sm font-bold text-blue-600">{getInitials(selectedChat.userName)}</div><div className="min-w-0"><div className="flex flex-wrap items-center gap-2"><h2 className="truncate text-base font-bold text-slate-800 sm:text-lg">{selectedChat.userName}</h2><span className="rounded-full bg-blue-50 px-2 py-0.5 text-[10px] font-semibold text-blue-600">Chat History</span></div><p className="mt-0.5 truncate text-xs text-slate-500">{selectedChat.email}</p></div></div><button onClick={() => setShowChatModal(false)} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"><X size={20}/></button></div>
            <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-4"><div className="rounded-xl bg-slate-50 px-3 py-2.5"><p className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">Date</p><p className="mt-1 text-xs font-bold text-slate-700">{formatDate(selectedChat.startedAt)}</p></div><div className="rounded-xl bg-slate-50 px-3 py-2.5"><p className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">Started</p><p className="mt-1 text-xs font-bold text-slate-700">{formatTime(selectedChat.startedAt)}</p></div><div className="rounded-xl bg-slate-50 px-3 py-2.5"><p className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">Account ID</p><p className="mt-1 text-xs font-bold text-slate-700">{selectedChat.accountId}</p></div><div className="rounded-xl bg-slate-50 px-3 py-2.5"><p className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">Messages</p><p className="mt-1 text-xs font-bold text-slate-700">{selectedChat.messages.length}</p></div></div>
          </div>

          <div className="min-h-0 flex-1 overflow-y-auto bg-[#f8fafc] px-3 py-5 sm:px-6 sm:py-6"><div className="mx-auto w-full max-w-4xl space-y-6">
            {selectedChat.messages.map((message) => { const bot = isBot(message); const messageDate = new Date(message.ts); return <div key={message.message_id} className={`flex w-full gap-3 ${bot ? 'justify-start' : 'justify-end'}`}>
              {bot && <div className="mt-6 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-600"><Bot size={17}/></div>}
              <div className={`flex max-w-[92%] flex-col sm:max-w-[78%] ${bot ? 'items-start' : 'items-end'}`}>
                <div className={`mb-1.5 flex flex-wrap items-center gap-2 ${bot ? 'justify-start' : 'justify-end'}`}><span className="text-[11px] font-bold text-slate-600">{bot ? 'AI Bot' : selectedChat.userName}</span><span className="flex items-center gap-1 text-[10px] text-slate-400"><Clock3 size={11}/>{formatDate(messageDate)} • {formatTime(messageDate)}</span></div>
                <div className={`w-fit max-w-full rounded-2xl px-4 py-3.5 text-sm leading-6 shadow-sm ${bot ? 'rounded-tl-md border border-slate-200 bg-white text-slate-700' : 'rounded-tr-md bg-blue-600 text-white'}`}><div className="whitespace-pre-wrap break-words">{stripHtml(message.msg || '')}</div></div>
                <span className="mt-1.5 text-[9px] text-slate-400">Message ID: {message.message_id}</span>
              </div>
              {!bot && <div className="mt-6 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-600 text-white"><User size={16}/></div>}
            </div>; })}
          </div></div>

          <div className="shrink-0 border-t border-slate-200 bg-white px-4 py-3 sm:px-6"><div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between"><div className="min-w-0"><p className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">Track ID</p><p className="truncate text-xs font-semibold text-slate-600">{selectedChat.trackId}</p></div><div className="flex w-full gap-2 sm:w-auto"><button onClick={() => setShowUpdateModal(true)} className="flex-1 rounded-xl border border-slate-200 px-4 py-2.5 text-xs font-semibold text-slate-700 hover:bg-slate-50 sm:flex-none">Update Date</button><button onClick={() => setShowChatModal(false)} className="flex-1 rounded-xl bg-slate-800 px-5 py-2.5 text-xs font-semibold text-white transition hover:bg-slate-900 sm:flex-none">Close</button></div></div></div>
        </div>
      </div>}

      {showUpdateModal && selectedChat && <div className="fixed inset-0 z-[110] flex items-center justify-center bg-slate-950/50 p-4 backdrop-blur-sm" onClick={() => setShowUpdateModal(false)}><div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl" onClick={(e) => e.stopPropagation()}><div className="flex items-start justify-between"><div><h3 className="text-lg font-bold text-slate-800">Update Chat Date</h3><p className="mt-1 text-xs text-slate-500">Update the date for <span className="font-semibold">{selectedChat.userName}</span>'s conversation.</p></div><button onClick={() => setShowUpdateModal(false)} className="rounded-lg p-1.5 text-slate-400 hover:bg-slate-100"><X size={18}/></button></div><div className="mt-5"><label className="mb-1.5 block text-xs font-semibold text-slate-500">New Chat Date</label><DatePicker value={updatedDates[selectedChat.trackId] ? dayjs(updatedDates[selectedChat.trackId]) : dayjs(selectedChat.startedAt)} onChange={(date) => handleUpdateDate(date?.format("YYYY-MM-DD"))} format="DD MMM YYYY" className="!h-[42px] !w-full" /></div><div className="mt-5 flex justify-end"><button onClick={() => setShowUpdateModal(false)} className="rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-600">Cancel</button></div></div></div>}

      {showExportModal && <div className="fixed inset-0 z-[110] flex items-center justify-center bg-slate-950/50 p-4 backdrop-blur-sm" onClick={() => setShowExportModal(false)}><div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl" onClick={(e) => e.stopPropagation()}><div className="flex items-start justify-between"><div><h3 className="text-lg font-bold text-slate-800">Export Chat History</h3><p className="mt-1 text-xs text-slate-500">Export chats from the selected date range.</p></div><button onClick={() => setShowExportModal(false)} className="rounded-lg p-1.5 text-slate-400 hover:bg-slate-100"><X size={18}/></button></div><div className="mt-5 rounded-xl bg-slate-50 p-4"><p className="text-xs font-semibold text-slate-500">Selected range</p><p className="mt-1 text-sm font-bold text-slate-700">{fromDate ? dayjs(fromDate).format("DD MMM YYYY") : 'Any date'} → {toDate ? dayjs(toDate).format("DD MMM YYYY") : 'Any date'}</p><p className="mt-1 text-xs text-slate-400">{filteredConversations.length} conversations will be exported.</p></div><div className="mt-5 flex justify-end gap-2"><button onClick={() => setShowExportModal(false)} className="rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-600">Cancel</button><button onClick={exportCsv} className="rounded-xl bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-700"><Download size={14} className="mr-1 inline"/>Export CSV</button></div></div></div>}
    </>
  );
}
